import { StyledHtmlText } from '../../../../../../inputs/rich-text/style/StyledHtmlText.tsx';
import { cachedSanitizeHtml } from '../../../../../../ui/html/cachedSanitizeHtml.ts';

export interface IAdvancedSelectRichTextValueProps {
  value: string | null;
  emptyValue?: string;
  inline?: boolean;
}

/**
 * Renderizza il valore di una colonna RichText.
 *
 * Il valore è già HTML valido: prodotto dall'editor (TipTap) oppure
 * normalizzato all'ingresso (import CSV, conversione tipo). Al render si
 * sanifica soltanto con DOMPurify, senza alcuna ri-conversione.
 */
export function AdvancedSelectRichTextValue(
  props: IAdvancedSelectRichTextValueProps,
) {
  const { value, emptyValue = '-', inline } = props;

  if (value == null || value === '') return <span>{emptyValue}</span>;

  return (
    <StyledHtmlText
      as="div"
      inline={inline}
      // biome-ignore lint/security/noDangerouslySetInnerHtml: HTML sanitized before render
      dangerouslySetInnerHTML={{
        __html: cachedSanitizeHtml(String(value)),
      }}
    />
  );
}
